import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services';


@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.css']
})
export class PagesComponent implements OnInit {

  isLoggedIn: boolean;

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() {

    this.isLoggedIn = this.authService.isLoggedIn();

    this.authService.listenerIsLoggedIn().subscribe(value => {

      this.isLoggedIn = value;
    });
  }
}
